<template>
  <div class="wallet-page">
    <div class="breadcrumb-wrap">
      <h2>Dashboard</h2>
      <ul class="breadcrumb">
        <li>
          <router-link :to="{name: 'Home'}"><i class="bx bxs-home"></i>Home</router-link>
        </li>
        <li>
          <span>Dashboard</span>
        </li>
      </ul>
    </div>
    <div class="overview-box">
      <div class="item user-level">
        <div class="item-icon">
          <img :src="`/assets/images/user-level/${userOverview.role || 'user'}.png`" alt="Icon">
        </div>
        <div class="item-head">
          <h4>User Level</h4>
        </div>
        <div class="item-content">
          <span class="number">{{ userOverview.role }}</span>
        </div>
      </div>
      <div class="item">
        <div class="item-icon" style="background-color: #23b7e5;">
          <i class="ti ti-users fs-16"></i>
        </div>
        <div class="item-head">
          <h4>Total My Invite</h4>
        </div>
        <div class="item-content">
          <span class="number">{{ userOverview.totalMember }}</span>
          <div class="view-all">
            <router-link :to="{name: 'affiliate'}">View detail <i class="ti ti-arrow-narrow-right ms-2 fw-semibold d-inline-block"></i></router-link>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="item-icon" style="background-color: #26bf94;">
          <i class="ti ti-wallet fs-16"></i>
        </div>
        <div class="item-head">
          <h4>Total My Invest</h4>
        </div>
        <div class="item-content">
          <span class="number">${{ userOverview.beautyTotalBuy}}</span>
          <div class="view-all">
            <router-link :to="{name: 'affiliate'}">View detail <i class="ti ti-arrow-narrow-right ms-2 fw-semibold d-inline-block"></i></router-link>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="item-icon" style="background-color: #f5b849;">
          <i class="ti ti-wave-square fs-16"></i>
        </div>
        <div class="item-head">
          <h4>Accumulated Profit</h4>
        </div>
        <div class="item-content">
          <span class="number">${{ userMaxout.beautyTotalCom }}</span>
          <div class="view-all">
            <router-link :to="{name: 'affiliate'}">View detail <i class="ti ti-arrow-narrow-right ms-2 fw-semibold d-inline-block"></i></router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="balance-box" v-if="balances.length" :class="{ 'loading': isLoadingBalance }">
      <div class="title">
        <h2>Assets</h2>
      </div>
      <div class="items">
        <div class="item" v-for="balance in balances" :key="balance.id">
          <div class="item-head">
            <img :src="`/assets/images/icons/${balance.currency.toLowerCase()}.png`" :alt="balance.currency">
            <div class="item-body">
              <span>{{ balance.name }}</span>
              <div class="flex-box">
                <span class="number">{{ balance.beautyBalance }}</span>
                <span class="text">{{ balance.displaySymbol }}</span>
                <span class="text"> {{ balance.currency }}</span>
              </div>
            </div>
          </div>
          <div class="item-footer">
            <el-button
              v-if="balance.currency == 'USDT'"
              :disabled="!balance.is_allow_deposit || isLockedDeposit"
              @click.prevent="openDepositAddress">Deposit</el-button>
            <el-button :disabled="!balance.is_allow_withdraw" @click.prevent="openWithdrawForm(balance)">Withdraw</el-button>
          </div>
        </div>
        <div class="item">
          <div class="item-head">
            <img src="/assets/images/icons/ppst.png" alt="PPST">
            <div class="item-body">
              <span>PPST</span>
              <div class="flex-box">
                <span class="number">{{ totalPps.beautyTotalBuy }}</span>
                <span class="text"></span>
                <span class="text">PPST</span>
              </div>
            </div>
          </div>
          <div class="item-head">
            <img src="/assets/images/icons/aleo.png" alt="Aleo">
            <div class="item-body">
              <span>Proof Target</span>
              <div class="flex-box">
                <span class="number">{{ totalPps.totalPpsByRate }}</span>
                <span class="text"></span>
                <span class="text">S/s</span>
              </div>
            </div>
          </div>
          <div class="item-footer">
            <el-button @click="buyMore(true)" v-if="false">Buy more</el-button>
          </div>
        </div>

        <div class="item">
          <div class="item-head">
            <img src="/assets/images/icons/gh.png" alt="GH">
            <div class="item-body">
              <span>Gh/s</span>
              <div class="flex-box">
                <span class="number">{{ totalPps.kasAmount || 0 }}</span>
                <span class="text"></span>
                <span class="text">Gh/s</span>
              </div>
            </div>
          </div>
          <div class="item-footer">
            <el-button @click="buyMore(false)" v-if="false">Buy more</el-button>
          </div>
        </div>

      </div>
    </div>
    <div class="commission-box">
      <div class="item">
        <div class="item-head">
          <h4><img src="/assets/images/icons/commission-2.png" alt="Commission">Referral Commission</h4>
        </div>
        <div class="item-body">
          <div class="flex-box"><img src="/assets/images/icons/usdt.png" alt="USDT"><span class="number">{{ userOverview.beautyTotalComRefU }}</span><span class="text">USDT</span></div>
          <div class="flex-box"><img src="/assets/images/icons/aleo.png" alt="ALEO"><span class="number">{{ userOverview.beautyTotalComRefA }}</span><span class="text">ALEO</span></div>
          <div class="flex-box"><img src="/assets/images/icons/kas.png" alt="KAS"><span class="number">{{ userOverview.beautyTotalComRefK }}</span><span class="text">KAS</span></div>
        </div>
        <div class="item-footer">
          <el-button @click="goToHistory">Show History</el-button>
          <h5><i class="el-icon-alarm-clock"></i>Payout daily commission</h5>
          <flip-countdown :deadline="deadline" :showDays="false" countdownSize="20px" labelSize="15px"></flip-countdown>
          <!-- <p><span class="number-time">06</span>hours : <span class="number-time">54</span>mins : <span class="number-time">42</span>seconds</p> -->
        </div>
        <div class="item-tip">
          <i class="el-icon-info"></i>
          <em>Note: Commissions daily will be paid daily at 00:00 UTC</em>
        </div>
      </div>
      <div class="item">
        <div class="item-head">
          <h4><img src="/assets/images/icons/commission-2.png" alt="Commission">Rank Commission</h4>
        </div>
        <div class="item-body">
          <div class="flex-box"><img src="/assets/images/icons/usdt.png" alt="USDT"><span class="number">{{ userOverview.beautyTotalComBrandU }}</span><span class="text">USDT</span></div>
          <div class="flex-box"><img src="/assets/images/icons/aleo.png" alt="ALEO"><span class="number">{{ userOverview.beautyTotalComBrandA }}</span><span class="text">ALEO</span></div>
          <div class="flex-box"><img src="/assets/images/icons/kas.png" alt="KAS"><span class="number">{{ userOverview.beautyTotalComBrandK }}</span><span class="text">KAS</span></div>
        </div>
        <div class="item-footer">
          <el-button @click="goToHistory">Show History</el-button>
          <h5><i class="el-icon-alarm-clock"></i>Payout daily commission</h5>
          <flip-countdown :deadline="deadline" :showDays="false" countdownSize="20px" labelSize="15px"></flip-countdown>
          <!-- <p><span class="number-time">06</span>hours : <span class="number-time">54</span>mins : <span class="number-time">42</span>seconds</p> -->
        </div>
        <div class="item-tip">
          <i class="el-icon-info"></i>
          <em>Note: Commissions daily will be paid daily at 00:00 UTC</em>
        </div>
      </div>
      <div class="item">
        <div class="item-head">
          <h4><img src="/assets/images/icons/mining.png" alt="mining">Mining</h4>
        </div>
        <div class="item-body">
          <div class="flex-box"><img src="/assets/images/icons/aleo.png" alt="ALEO"><span class="number">{{ userOverview.aleoMining || 0 }}</span><span class="text">ALEO</span></div>
          <div class="flex-box"><img src="/assets/images/icons/iron.png" alt="IRON"><span class="number">{{ userOverview.ironMining || 0 }}</span><span class="text">IRON</span></div>
          <div class="flex-box"><img src="/assets/images/icons/kas.png" alt="KAS"><span class="number">{{ userOverview.kasMining || 0 }}</span><span class="text">KAS</span></div>
        </div>
        <div class="item-footer">
          <el-button @click="goToHistory">Show History</el-button>
          <h5><i class="el-icon-alarm-clock"></i>Payout daily mining</h5>
          <flip-countdown :deadline="deadline" :showDays="false" countdownSize="20px" labelSize="15px"></flip-countdown>
          <!-- <p><span class="number-time">06</span>hours : <span class="number-time">54</span>mins : <span class="number-time">42</span>seconds</p> -->
        </div>
        <div class="item-tip">
          <i class="el-icon-info"></i>
          <em>Note: Mining daily will be paid daily at 00:00 UTC</em>
        </div>
      </div>
    </div>
    <div class="invite-box">
      <div class="title">
        <h2>Referral Info</h2>
      </div>
      <div class="item">
        <div class="item-info">
          <h4>Invite Code</h4>
          <div class="input-wrap">
            <el-input :value="`${userOverview.code}`"></el-input>
            <el-button @click="copy(userOverview.code)"><i class="el-icon-copy-document"></i>Copy</el-button>
          </div>
        </div>
        <div class="item-info">
          <h4>Invite Link</h4>
          <div class="input-wrap">
            <el-input :value="inviteLink"></el-input>
            <el-button @click="copy(inviteLink)"><i class="el-icon-copy-document"></i>Copy</el-button>
          </div>
        </div>
        <div class="item-social">
          <h4>Share to</h4>
          <!-- <share :config="config"></share> -->

          <div class="socials">
            <a href="#"><img src="/assets/images/icons/socials/facebook.png" alt="Icon"></a>
            <a href="#"><img src="/assets/images/icons/socials/twitter.png" alt="Icon"></a>
            <a href="#"><img src="/assets/images/icons/socials/whatsapp.png" alt="Icon"></a>
            <a href="#"><img src="/assets/images/icons/socials/telegram.png" alt="Icon"></a>
          </div>
        </div>
        <div class="item-tip">
          <i class="el-icon-info"></i>
          <em>Note: To use the referral link and receive the commission, you need to buy a minimum investment package of $100</em>
          <router-link :to="{name: 'BuyPackage'}" v-if="false"> Invest Now</router-link>
        </div>
      </div>
    </div>
    <div class="history-section">
      <div class="table-box">
        <div class="title">
          <h2>Wallet History</h2>
        </div>
        <div class="table-fixed-wrap">
          <div class="table-box-inner">
            <dl class="table-small2">
              <dt>
                <div class="item-no">{{ $t('TEXT_NO') }}.</div>
                <div>Amount</div>
                <div class="flex-1">Hash</div>
                <div class="width-1_5x">Type</div>
                <div>Status</div>
                <div class="flex-1">Time</div>
              </dt>
              <dd v-for="(item, index) in walletHistory" :key="item.hash">
                <div class="item-no">{{ index + 1}}</div>
                <div>{{ item.amount }} {{ item.currency}}</div>
                <div class="item-hash flex-1">
                  <template v-if="item.hashBeauty">
                    {{ item.hashBeauty }}
                    <i class="el-icon-copy-document" @click="copy(item.hash)"></i>
                    <a :href="`${configs[item.scanUrl]}${item.hash}`" target="_blank"><i class="el-icon-link"></i></a>
                  </template>
                </div>
                <div class="item-type width-1_5x">
                  <span :class="`${item.type.toLowerCase()}`">
                    <i class="el-icon-upload2" v-if="item.type === 'WITHDRAW'"></i>
                    <i class="el-icon-download" v-if="item.type === 'DEPOSIT'"></i>
                    {{ item.type.toLowerCase() }}
                  </span>
                </div>
                <div class="item-status">
                  <span :class="item.status.toLowerCase()">{{ item.status.toLowerCase()}}</span>
                </div>
                <div class="item flex-1">
                  {{ item.beautyTime }}
                </div>
              </dd>
              <dd v-if="walletPagination.totalPage">
                <el-pagination
                  :current-page="walletPagination.currentPage"
                  :page-count="walletPagination.totalPage"
                  background
                  layout="prev, pager, next"
                  @current-change="goToWalletHistoryPage"
                  :hide-on-single-page="true"
                >
                </el-pagination>
              </dd>
              <dd v-else class="no-data-wrap">
                <div class="no-data">{{ $t('TEXT_NO_DATA') }}</div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="isShowAmountForm" :close-on-click-modal="false"
      :destroy-on-close="true" class="popup-form">
      <component
        :wallet="currentWallet"
        :feeWallet="currentFeeWallet"
        :is="currentTypeComponent"
        transition="fade"
        transition-mode="out-in"
      />
    </el-dialog>
  </div>
</template>

<script>
import UtilService from '@/utils/UtilService'
import BigNumber from 'bignumber.js'
import SwapForm from '@/views/dashboard/components/SwapForm'
import TransferForm from '@/views/dashboard/components/TransferForm'
import FlipCountdown from 'vue2-flip-countdown'

export default {
  components: {
    FlipCountdown
  },
  data () {
    return {
      config: {},
      currentTab: 2,
      roundTab: 1,
      selectedBalance: {},
      currentRound: {},
      selectedSymbol: '',
      form: {
        amount: ''
      },
      interval: null,
      intervalDone: true,
      isProcessing: false,
      isLoadingHistory: false,
      isLoadingActiveRound: false,
      isLoadingBalance: false,
      currentType: null,
      currentWallet: {},
      currentFeeWallet: {},
      deadline: null,
      quickBuyList: [
        500, 1000, 2000, 5000, 10000, 20000, 50000, 100000
      ]
    }
  },
  computed: {
    totalPps () {
      return this.$store.getters.totalPps
    },
    userMaxout () {
      return this.$store.getters.userMaxout
    },
    walletPagination () {
      return this.$store.getters.walletPagination
    },
    inviteLink () {
      return `${window.location.origin}?ref=${this.userOverview.code}`
    },
    userOverview () {
      return this.$store.getters.userOverview
    },
    isLockedDeposit () {
      return !this.configs.isAllowDeposit || !this.user.allow_deposit
    },
    userConfig () {
      return this.$store.getters.userConfig
    },
    balances () {
      return this.$store.getters.balances
    },
    transactionHistory () {
      return this.$store.getters.transactionHistory
    },
    isLockedSwap () {
      return !this.configs.isAllowSwap || !this.user.allowSwap
    },
    isLockedTransfer () {
      return !this.configs.isAllowTransfer || !this.user.allowTransfer
    },
    currentTypeComponent () {
      let comp = null
      switch (this.currentType) {
        case 'SWAP':
          comp = SwapForm
          break
        case 'TRANSFER':
          comp = TransferForm
          break
        default:
          break
      }
      return comp
    },
    isShowAmountForm: {
      get () {
        return this.$store.getters.isShowAmountForm
      },
      set (val) {
        this.$store.dispatch('toggleAmountForm')
      }
    },
    configs () {
      return this.$store.getters.configs
    },
    user () {
      return this.$store.getters.user
    },
    pagination () {
      return this.$store.getters.pagination
    },
    isBalanceNotEnough () {
      return this.form.amount &&
        (new BigNumber(this.form.amount).comparedTo(this.maxAmountUsd) === 1 ||
        new BigNumber(this.form.amount).comparedTo(this.selectedBalance.balanceUsdt) === 1)
    },
    isBalanceIsNotValid () {
      return this.form.amount &&
        (isNaN(this.form.amount) || new BigNumber(this.form.amount).comparedTo(this.minAmountUsd) !== 1)
    },
    minAmountUsd () {
      return this.selectedBalance.balanceUsdt >= this.activeRound.minAmountUsd ? this.activeRound.minAmountUsd : this.selectedBalance.balanceUsdt
    },
    maxAmountUsd () {
      return this.selectedBalance.balanceUsdt >= this.activeRound.maxAmountUsd ? this.activeRound.maxAmountUsd : this.selectedBalance.balanceUsdt
    },
    activeRound () {
      return this.$store.getters.activeRound
    },
    ieoBalances () {
      return this.$store.getters.ieoBalances
    },
    ieoBalancesActive () {
      return this.ieoBalances.filter(balance => {
        return balance.allowIeo
      })
    },
    commissionHistory () {
      return this.$store.getters.commissionHistory
    },
    commissionAleoHistory () {
      return this.$store.getters.commissionAleoHistory
    },
    commissionBrandHistory () {
      return this.$store.getters.commissionBrandHistory
    },
    isValidated () {
      return this.form.amount && !isNaN(this.form.amount) && parseFloat(this.form.amount) > 0 &&
        this.userConfig.is_allow_buy &&
        UtilService.isInteger(this.form.amount) &&
        new BigNumber(this.form.amount).comparedTo(this.userConfig.min_buy) !== -1 &&
        new BigNumber(this.form.amount).comparedTo(this.userConfig.max_buy) !== 1
    },
    estimatedAmount () {
      if (!this.isValidated || !this.selectedBalance.symbol) return 0
      return UtilService.calculateAmount(this.form.amount, this.activeRound.tokenPrice, this.selectedBalance.numberDecimal)
    },
    isConnected () {
      return this.$store.getters.isConnected
    },
    walletHistory () {
      return this.$store.getters.walletHistory
    },
    userKyc () {
      return this.$store.getters.userKyc
    }
  },
  watch: {
    ieoBalancesActive (n, o) {
      if (!this.selectedBalance.symbol && n.length) {
        this.selectedBalance = n[0]
        this.selectedSymbol = n[0].symbol
      } else {
        this.selectedBalance = n.filter((temp) => temp.symbol === this.selectedBalance.symbol)[0]
      }
    },
    selectedSymbol (symbol) {
      if (symbol) {
        this.selectedBalance = this.ieoBalancesActive.filter(temp => temp.symbol === symbol)[0]
      }
    },
    activeRound (val) {
      if (val.id && !this.currentRound.id) {
        this.currentRound = val
      }
    }
  },
  async created () {
    const date = new Date()
    date.setDate(date.getDate() + 1)
    date.setUTCHours(0)
    date.setUTCMinutes(0)
    date.setUTCSeconds(0)
    this.deadline = date.toUTCString()
    this.isLoadingBalance = true
    this.$store.dispatch('getBalances').then(rs => {
      setTimeout(() => {
        this.isLoadingBalance = false
      }, 500)
    })
    this.$store.dispatch('getWalletTransactionHistory', { page: 1 }).then(rs => {
    })
    this.$store.dispatch('getUserKyc')
    this.$store.dispatch('getUserMaxout').then(rs => {})
    this.updateBalance()
  },
  methods: {
    buyMore (isAleo) {
      isAleo ? this.$router.push({ name: 'BuyPackage' }) : this.$router.push({ name: 'BuyPackageKas' })
    },
    copy (text) {
      text = text + ''
      this.$copyText(text).then(e => {
        this.$store.dispatch('showSuccessMsg', this.$t('TEXT_COPIED', 'Copied'))
      })
    },
    openWithdrawForm (item) {
      if (item.is_require_kyc_withdraw && this.userKyc.kycStatus !== 'APPROVED') {
        this.$confirm('You have to complete your KYC application to continue!', 'Confirm', {
          confirmButtonText: 'Confirm',
          dangerouslyUseHTMLString: true,
          iconClass: 'no-icon',
          customClass: 'buy-confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.$router.push({ name: 'kyc' })
        }).catch(() => {
        })
        return
      }
      this.$store.dispatch('setWithdrawModalData', item)
      this.$store.dispatch('toggleWithdrawForm')
    },
    openDepositAddress () {
      if (this.isLockedDeposit) return
      this.$store.dispatch('toggleDepositAddressForm')
    },
    openDeposit () {
      console.log('deposit')
      if (!this.isConnected) {
        this.showWalletProviders()
        return
      }
      if (this.isLockedDeposit) return
      this.$store.dispatch('toggleDepositForm')
    },
    showWalletProviders () {
      this.$store.dispatch('toggleWalletProviderForm')
    },
    doAction (wallet, type) {
      if (type === 'SWAP') {
        if (!wallet.allowSwap || this.isLockedSwap) {
          return
        }
      } else if (type === 'TRANSFER') {
        if (!wallet.allowTransferIeoToMain || this.isLockedTransfer || wallet.balanceIeo === 0) {
          return
        }
      }
      this.currentType = type
      this.currentWallet = wallet
      if (wallet.withdrawFeeSymbol && wallet.withdrawFeeSymbol !== wallet.symbol) {
        this.currentFeeWallet = this.balances.filter((temp) => temp.symbol === wallet.withdrawFeeSymbol)[0] || wallet
      }
      this.$store.dispatch('toggleAmountForm')
    },
    goToWalletHistoryPage (page) {
      const temp = JSON.parse(JSON.stringify(this.walletPagination))
      temp.page = page
      this.$store.dispatch('setWalletHistoryPagination', temp)
      this.$store.dispatch('getWalletTransactionHistory', { page })
    },
    updateBalance () {
      if (this.interval) return
      this.interval = setInterval(() => {
        if (!this.intervalDone) return
        this.intervalDone = false
        this.$store.dispatch('getBalances').then(rs => {
          this.intervalDone = true
        })
      }, 3500)
    },
    goToHistory () {
      this.$router.push({ name: 'Commission' })
    },
    goToBuyPackage () {
      this.$router.push({ name: 'BuyPackage' })
    }
  },
  destroyed () {
    clearInterval(this.interval)
  }
}
</script>
